type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

/** `Object.entriesOf` with correct types */
export function entriesOf<T extends Record<string, unknown>>(record: T): Entries<T> {
  return Object.entries(record) as Entries<T>;
}
